import React from 'react';
import { Link } from 'react-router-dom';


const NavBar = () => (

    <nav>
        <ul>
            <li>
                <Link to="/">Home</Link>
            </li>
            <li>
                <Link to="/services">Services</Link>
            </li>
            <li>
                <Link to="/gallery">Gallery</Link>
            </li>
            <li>
                <Link to="/about">About</Link>
            </li>

            <li>
                <Link to="/shows">Shows</Link>
            </li>
        </ul>
    </nav>

);

export default NavBar;